// Text for the Disconnect confirmation on Bank Feeds. Disconnecting ends the
// bank connection (Plaid /item/remove). Imported transactions stay. On plans
// with a connection limit, a removed connection still counts, so reconnecting
// the same bank uses another slot. "Fix connection" (update mode) repairs the
// existing connection instead.
export function accountLabel(a) {
  const name = a.name || a.official_name || 'Account';
  return a.mask ? `${name} ${a.mask}` : name;
}

export function disconnectMessage(item) {
  const bank = item.institution_name || 'this bank';
  const accounts = (item.accounts || []).map(accountLabel);
  return [
    `Disconnect ${bank}?`,
    accounts.length ? `Accounts: ${accounts.join(', ')}.` : null,
    'Transactions already imported stay in eloNest. New bank activity stops coming in.',
    'Reconnecting later creates a new connection, which uses another connection slot on plans with a connection limit.',
    'If the connection is broken or asks you to sign in again, use "Fix connection" instead.'
  ].filter(Boolean).join('\n\n');
}